<template>
  <b-modal ref="manualRefundmodal" visible size="lg" :hide-footer="true" title="Manual Refund" @hidden="$emit('close')">

    <div class="block block-bordered">
      <div class="block-header block-header-default">
        <h3 class="block-title">
          Manual Retour
        </h3>
      </div>
      <div class="block-content">
          <div class="block-content p-0 row">
            <label style="margin:right 50px;">Voer een order nummer in: </label>
            <input list="orders" v-model="OrderNumber" ref="searchInput" v-on:input="getOrders" class="form-control" :placeholder="`Bijvoorbeeld: NL-123456`">
            <datalist id="orders" >
              <option v-for="item in orders" :key="item.id">{{item.number}}</option>
            </datalist>
            <button type="submit" class="btn btn-success btn-noborder" @click="loadOrder">
              <i class="fa fa-check"></i>
            </button>
          </div>
      </div>
    </div>
      <refund-form v-if="order !== null && refund !== null" :order-id="order.id" :refundId="refund.id" :includeRefundShipmentCosts="false" ></refund-form>
  </b-modal>
</template>
<script>
import RefundForm from './RefundForm.vue'
export default {
  components: {
    RefundForm
  },
  data () {
    return {
      OrderNumber: null,
      order: null,
      orders: [],
      refund: null
    }
  },
  methods: {
    loadOrder () {
      const params = {
        include: 'lines,lines.product,shipment,returnShipment,refund'
      }
      params[`filter[search]`] = this.OrderNumber

      return this.$api.getOrders(params)
        .then((result) => {
          this.order = result.data.data[0]
          this.lines = this.order.lines
          this.createRefund()
        })
        .catch(() => {
          this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het ophalen van de ${this.itemLabelPlural}. Probeer het opnieuw.`, 'error')
          return []
        })
    },

    getOrders () {
      const params = {
      }
      params[`filter[search]`] = this.OrderNumber

      return this.$api.getOrders(params)
        .then((response) => {
          this.orders = response.data.data
          return response.data.data
        })
        .catch(() => {
          this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het ophalen van de ${this.itemLabelPlural}. Probeer het opnieuw.`, 'error')
          return []
        })
    },
    createRefund () {
      const data = {
        order_number: this.OrderNumber
      }

      this.$http.post(`/refunds`, data)
        .then((response) => {
          this.saving = false
          this.alert = { variant: 'success', message: 'Opgeslagen' }
          this.refund = response.data.data
        })
        .catch(() => {
          this.saving = false
          this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het aanmaken van de retour. Probeer het opnieuw.`, 'error')
        })
    }
  }
}
</script>

<style scoped>
a.disabled.block {
  cursor: not-allowed;
  opacity: 0.5;
}


</style>



// WEBPACK FOOTER //
// ManualRefundModal.vue?70b29f0f